import { has, get, first } from 'lodash';
const AUTH_PATH = '/users/authenticate';

const defaultMessage = (status) => {
  if (status === 401) return 'Unauthorized';
  if (status === 403) return 'Forbidden';
  if (status === 404) return 'Not found';
  if (status === 422) return 'Unprocessable entity';
  if (status === 500) return 'Server error';
  return 'Something went wrong';
}

class ApiError extends Error {
  constructor({ response: { data, status, request }, response }) {
    super('ApiError');
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
    this.name = 'ApiError';
    this.status = typeof status === 'number' ? status : parseInt(status, 10);
    this.isApiError = true;
    this.response = response;
    this.responseURL = get(response, 'request.responseURL', 'unknown');
    this.fromAuthentication = this.responseURL.indexOf(AUTH_PATH) !== -1
    this.is401 = this.status === 401;
    this.is403 = this.status === 403;
    this.is404 = this.status === 404;
    this.is422 = this.status === 422;
    this.is500 = this.status === 500;

    this.messages = get(data, 'errors', [defaultMessage(status)]);
    const errMsg = first(this.messages);
    this.message = errMsg.message ? errMsg.message : errMsg;
  }

  static isApiError(error) {
    if (has(error, 'response.status')) return new ApiError(error);
  }
}

export default ApiError;



// WEBPACK FOOTER //
// ./src/lib/api-error.js